/**
 * Enum representing the types of locations from where a Python project
 * might be loaded. Right now, we only support "SingleFile", but we will
 * support "Git" in the future.
 */
export const PythonApplicationLoadSource = Object.freeze({
  SingleFile  : 'singleFile',
  Git         : 'git'
});